import { css } from '@emotion/react';

import * as Icons from './components';

export type IconSize =
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge';

export const IconSizeMap: Record<IconSize, { width: number; height: number }> =
  {
    xsmall: {
      width: 12,
      height: 12,
    },
    small: {
      width: 16,
      height: 16,
    },
    medium: {
      width: 20,
      height: 20,
    },
    large: {
      width: 26,
      height: 26,
    },
    xlarge: {
      width: 32,
      height: 32,
    },
    xxlarge: {
      width: 48,
      height: 48,
    },
    xxxlarge: {
      width: 64,
      height: 64,
    },
  };

export type IconVariantTypes = keyof typeof Icons;

export type IconProps = {
  variant: IconVariantTypes;
  size?: IconSize;
  className?: string;
  setAutoHeight?: boolean;
  onClick?: () => void;
  fill?: string;
};

const iconStyles = (
  size: IconSize,
  setAutoHeight: boolean,
  fill?: string
) => css`
  width: ${IconSizeMap[size].width}px;
  height: ${IconSizeMap[size].height}px;
  ${setAutoHeight && 'height: auto;'}
  fill: ${fill ?? 'currentColor'};
`;

const Icon = ({
  variant,
  size = 'medium',
  className,
  setAutoHeight = false,
  fill,
  ...rest
}: IconProps) => {
  const Component = Icons[variant];

  if (!Component) {
    console.warn(`Invalid icon variant [${variant}]`);
    return null;
  }

  return (
    <Component
      css={iconStyles(size, setAutoHeight, fill)}
      className={className}
      {...rest}
    />
  );
};

export default Icon;
